export class DoorInsulationLevel {
  _id: string;
  name: string;
  description: string;
  features: string[];
}